export const IS_MAC = typeof navigator !== 'undefined' && /mac/i.test(navigator.userAgent);
export const MOD_KEY = IS_MAC ? '\u2318' : 'Ctrl';
export const MOD_ALT_KEY = IS_MAC ? '\u2318\u2325' : 'Ctrl+Alt';
